import React from "react";
import { connect } from "react-redux";
import { withRouter } from "react-router-dom";
import {
  putClientManagementDetails,
  putClientUserDetails,
  getClientManagementList,
  getClientUserDetails,
  getClientManagementDetails,
} from "../Actions/ClientManagementAPI";
import { confirmAlert } from "react-confirm-alert";
import axios from "axios";
import swal from "sweetalert";
import 'react-confirm-alert/src/react-confirm-alert.css';
import API from "../helpers/api";
import { toast } from "react-toastify";
import Role from "../helpers/role";

let searchData = {
  Name: "",
  PageNumber: 1,
  PageSize: 25,
};
let userRole = localStorage.getItem("UserRoles");
let currentUser = JSON.parse(localStorage.getItem("currentUser"));

class ClientManagementDetail extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      id: "",
    };
  }

  componentDidMount() {
    const { match, dispatch } = this.props;
    const { params } = match;
    const { id } = params;
    dispatch(getClientUserDetails(id));
    // dispatch(getClientManagementDetails(id));
  }
  componentDidUpdate() {
    const { dispatch, match } = this.props;
    window.onpopstate = (e) => {
      //your code...
      this.setState({ showSidePane: false });
      this.props.dispatch({ type: "ShowSidePan", data: false });
      this.props.history.push("/Home/Management/Client");

      //   this.props.history.push("/Home/Management/Device");
    };
  }
  ShowSidePanel = () => {
    this.setState({ showSidePane: false });
    this.props.dispatch({ type: "ShowSidePan", data: false });
    this.props.history.push("/Home/Management/Client");
  };
  render() {
    const { ClientDetails, clientUserList } = this.props;
    let fleetManager =
      clientUserList && clientUserList.filter((r) => r.userRole === "fleetmanager");
    let techSuperintendent =
      clientUserList &&
      clientUserList.filter((r) => r.userRole === "superintendent");
    let techExecutive =
      clientUserList &&
      clientUserList.filter((r) => r.userRole === "technicalexecutive");

    const isEmailNotificationEnabled =
      !!(ClientDetails && ClientDetails.mailAlertForLevel2AndMonthlyReport);
    const level2ToEmail =
      ClientDetails &&
      (Array.isArray(ClientDetails.level2ToMailForAlert)
        ? ClientDetails.level2ToMailForAlert.join(", ")
        : ClientDetails.level2ToMailForAlert || "");
    const level2CcEmail =
      ClientDetails &&
      (Array.isArray(ClientDetails.level2CcMailForAlert)
        ? ClientDetails.level2CcMailForAlert.join(", ")
        : ClientDetails.level2CcMailForAlert || "");
    const monthlyToEmail =
      ClientDetails &&
      (Array.isArray(ClientDetails.monthlyReportToMailForAlert)
        ? ClientDetails.monthlyReportToMailForAlert.join(", ")
        : ClientDetails.monthlyReportToMailForAlert || "");
    const monthlyCcEmail =
      ClientDetails &&
      (Array.isArray(ClientDetails.monthlyReportCcMailForAlert)
        ? ClientDetails.monthlyReportCcMailForAlert.join(", ")
        : ClientDetails.monthlyReportCcMailForAlert || "");
    return (
      <div className="full-height">
        <div className="pt-3">
          <div className="row pt-4 pb-3"> </div>
          <div className="row pt-3">
            <div className="col-lg-12">
              <div className="resource-list-auth-date">
                <div className="panel-box search-filter-box">
                  <button
                    className="btn btn-primary text-uppercase txtside-btn txtht-btn blue"
                    onClick={() => this.ShowSidePanel()}
                  >
                    <div style={{ position: 'relative' }}>
                      <span className="backarr">&larr;</span> <span style={{ marginLeft: "18px" }}>Return</span>
                    </div>
                  </button>
                  <div
                    className="card mt-2 MM-card-header"
                    style={{ backgroundColor: "white" }}
                  >
                    <div
                      className="card-body"
                      style={{
                        padding: "0rem",
                        backgroundColor: "#1a3464",
                        color: "white",
                      }}
                    >
                      <h5
                        className="card-title m-2"
                        style={{ color: "092a51" }}
                      >
                        Client Details
                      </h5>
                    </div>
                    <div className="pt-3 pb-3 search-filter-box">
                      <div className="row">
                        <div className="col-sm-6">
                          <label className="form-label">Company Name :</label>
                          <span>
                            {" "}
                            {ClientDetails ? ClientDetails.name : ""}
                          </span>
                        </div>
                        <div className="col-sm-6">
                          <label className="form-label">Email :</label>
                          <span>
                            {" "}
                            {ClientDetails ? ClientDetails.mail : ""}
                          </span>
                        </div>
                        <div className="col-lg-6">
                          <label className="form-label">Phone :</label>
                          <span>
                            {" "}
                            {ClientDetails ? ClientDetails.phone : ""}
                          </span>
                        </div>
                        <div className="col-sm-6">
                          <label className="form-label">Address :</label>
                          <span>
                            {" "}
                            {ClientDetails ? ClientDetails.address : ""}
                          </span>
                        </div>
                      </div>
                    </div>
                    <div
                      className="card-body"
                      style={{
                        padding: "0rem",
                        backgroundColor: "#1a3464",
                        color: "white",
                      }}
                    >
                      <h5
                        className="card-title ml-2 mt-2"
                        style={{ color: "092a51" }}
                      >
                        Marine Manager
                      </h5>
                    </div>
                    <div className="pt-3 search-filter-box">
                      {fleetManager
                        ? fleetManager.map((item) => (
                          <div
                            className="card MM-card-content mb-2 click"
                            style={{
                              backgroundColor: "#f0f0f0",
                              overflow: "hidden",
                              position: "relative",
                            }}
                          >
                            <div className="p-3">
                              <div className="resource-list-auth-date">
                                <div className="row">
                                  <div className="col-sm-6 mb-2">
                                    <span>
                                      <strong>Name : </strong>
                                      <span className="italicFont ">
                                        {item.userName}
                                      </span>
                                    </span>
                                  </div>
                                  <div className="col-sm-6 mb-2">
                                    <span>
                                      <strong>Email : </strong>
                                      <span className="italicFont ">
                                        {item.email}
                                      </span>
                                    </span>
                                  </div>
                                  <div className="col-sm-6 mb-2">
                                    <span>
                                      <strong>Phone : </strong>
                                      <span className="italicFont ">
                                        {item.telephone}
                                      </span>
                                    </span>
                                  </div>
                                  {/* <div className="col-sm-6">
                                                                    <span><strong>PIC Contact Details : </strong><span className="italicFont ">{item.picContactDetails}</span></span>
                                                                </div> */}
                                </div>
                              </div>
                            </div>
                          </div>
                        ))
                        : null}
                    </div>
                    <div
                      className="card-body"
                      style={{
                        padding: "0rem",
                        backgroundColor: "#1a3464",
                        color: "white",
                      }}
                    >
                      <h5
                        className="card-title ml-2 mt-2"
                        style={{ color: "092a51" }}
                      >
                        Marine Superintendents
                      </h5>
                    </div>
                    <div className="pt-3 search-filter-box">
                      {techSuperintendent
                        ? techSuperintendent.map((item) => (
                          <div
                            className="card MM-card-content mb-2 click"
                            style={{
                              backgroundColor: "#f0f0f0",
                              overflow: "hidden",
                              position: "relative",
                            }}
                          >
                            <div className="p-3">
                              <div className="resource-list-auth-date">
                                <div className="row">
                                  <div className="col-sm-6 mb-2">
                                    <span>
                                      <strong>Name : </strong>
                                      <span className="italicFont ">
                                        {item.userName}
                                      </span>
                                    </span>
                                  </div>
                                  <div className="col-sm-6 mb-2">
                                    <span>
                                      <strong>Email : </strong>
                                      <span className="italicFont ">
                                        {item.email}
                                      </span>
                                    </span>
                                  </div>
                                  <div className="col-sm-6 mb-2">
                                    <span>
                                      <strong>Phone : </strong>
                                      <span className="italicFont ">
                                        {item.telephone}
                                      </span>
                                    </span>
                                  </div>
                                  {/* <div className="col-sm-6">
                                                                    <span><strong>PIC Contact Details : </strong><span className="italicFont ">{item.picContactDetails}</span></span>
                                                                </div> */}
                                </div>
                              </div>
                            </div>
                          </div>
                        ))
                        : null}
                    </div>
                    <div
                      className="card-body"
                      style={{
                        padding: "0rem",
                        backgroundColor: "#1a3464",
                        color: "white",
                      }}
                    >
                      <h5
                        className="card-title ml-2 mt-2"
                        style={{ color: "092a51" }}
                      >
                        DPA
                      </h5>
                    </div>
                    <div className="pt-3 search-filter-box">
                      {techExecutive
                        ? techExecutive.map((item) => (
                          <div
                            className="card MM-card-content mb-2 click"
                            style={{
                              backgroundColor: "#f0f0f0",
                              overflow: "hidden",
                              position: "relative",
                            }}
                          >
                            <div className="p-3">
                              <div className="resource-list-auth-date">
                                <div className="row">
                                  <div className="col-sm-6 mb-2">
                                    <span>
                                      <strong>Name : </strong>
                                      <span className="italicFont ">
                                        {item.userName}
                                      </span>
                                    </span>
                                  </div>
                                  <div className="col-sm-6 mb-2">
                                    <span>
                                      <strong>Email : </strong>
                                      <span className="italicFont ">
                                        {item.email}
                                      </span>
                                    </span>
                                  </div>
                                  <div className="col-sm-6 mb-2">
                                    <span>
                                      <strong>Phone : </strong>
                                      <span className="italicFont ">
                                        {item.telephone}
                                      </span>
                                    </span>
                                  </div>
                                  {/* <div className="col-sm-6">
                                                                    <span><strong>PIC Contact Details : </strong><span className="italicFont ">{item.picContactDetails}</span></span>
                                                                </div> */}
                                </div>
                              </div>
                            </div>
                          </div>
                        ))
                        : null}
                    </div>
                    <div
                      className="card-body"
                      style={{
                        padding: "0rem",
                        backgroundColor: "#1a3464",
                        color: "white",
                      }}
                    >
                      <h5
                        className="card-title ml-2 mt-2"
                        style={{ color: "092a51" }}
                      >
                        Email Notification
                      </h5>
                    </div>
                    <div className="pt-3 search-filter-box">
                      {isEmailNotificationEnabled ? (
                        <>
                          <div className="row pt-1">
                            <div className="col-sm-12 mb-2">
                              <label className="form-label">
                                Level 2 escalation email
                              </label>
                            </div>
                          </div>
                          <div className="row">
                            <div className="col-sm-6 mb-2">
                              <label className="form-label">To Email :</label>
                              <span> {level2ToEmail || "-"}</span>
                            </div>
                            <div className="col-sm-6 mb-2">
                              <label className="form-label">Cc Email :</label>
                              <span> {level2CcEmail || "-"}</span>
                            </div>
                          </div>
                          <div className="row pt-1">
                            <div className="col-sm-12 mb-2">
                              <label className="form-label">Monthly report email</label>
                            </div>
                          </div>
                          <div className="row">
                            <div className="col-sm-6 mb-2">
                              <label className="form-label">To Email :</label>
                              <span> {monthlyToEmail || "-"}</span>
                            </div>
                            <div className="col-sm-6 mb-2">
                              <label className="form-label">Cc Email :</label>
                              <span> {monthlyCcEmail || "-"}</span>
                            </div>
                          </div>
                        </>
                      ) : null}
                    </div>
                  </div>
                  <div className="row">
                    <div className="col-lg-12 pb-2 pt-2">
                      <div
                        className="search-btn-col mt-1"
                        style={{ textAlign: "right" }}
                      >
                        {userRole == Role.mmpl ? (<>
                          <button
                            className="btn btn-light text-uppercase txtside-btn txtht-btn ml-3"
                            type="button"
                            onClick={() => this.ShowSidePanel()}
                          >
                            {" "}
                            Cancel{" "}
                          </button>
                        </>) : (<>
                          <button
                            className="btn btn-primary text-uppercase txtside-btn txtht-btn blue"
                            type="submit"
                            onClick={() => this.EditClientDetails(ClientDetails)}
                          >
                            {" "}
                            Edit{" "}
                          </button>
                          <button
                            className="btn btn-light text-uppercase txtside-btn txtht-btn ml-3"
                            type="button"
                            onClick={() => this.DeleteClientDetails()}
                          >
                            {" "}
                            Delete{" "}
                          </button>
                        </>)}
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }

  DeleteClientDetails() {
    const { clientUserList, ClientDetails, history, dispatch } = this.props;
    confirmAlert({
      message: "Are you sure want to delete?",
      buttons: [
        {
          label: "Yes",
          onClick: () => {
            let userlist = clientUserList.map((item) => {
              let users = {
                clientId: item.shippingCompanyId,
                modifiedBy: "",
                clinetUserId: item.shippingCompanyUserId,
                userRole: item.role,
                userName: item.name,
                email: item.mail,
                address: item.address,
                picContactDetails: item.picContactDetails,
                isDeleted: true,
              };
              return users;
            });
            let client = {
              clientId: ClientDetails.shippingCompanyId,
              companyName: ClientDetails.name,
              mail: ClientDetails.mail,
              telephone: ClientDetails.phone,
              address: ClientDetails.address,
              mailAlert: true,
              isDeleted: true,
              modifiedBy: "",
            };
            let url = `${API.PutShippingCompany}`;
            axios
              .put(url, client, {
                headers: {
                  key: currentUser.accessToken,
                },
              })
              .then((response) => {
                dispatch(putClientUserDetails(userlist));
                this.ShowSidePanel();
                dispatch(getClientManagementList(searchData));
                dispatch({
                  type: "putClientDetailsSuccess",
                  data: response.data,
                });
                toast.success("Deleted Successfully", {
                  position: "top-right",
                  autoClose: 5000,
                  hideProgressBar: true,
                  closeOnClick: true,
                  pauseOnHover: true,
                  draggable: true,
                  progress: undefined,
                });
              })
              .catch((error) => {
                swal("Error!", "Something went wrong. Please try again.", "warning");
                dispatch({
                  type: "putClientDetailsFailure",
                  error: "ERROR",
                });
              });
          },
        },
        {
          label: "No",
          onClick: () => { },
        },
      ],
      overlayClassName: "custom-alert",
    });
  }
  EditClientDetails(item) {
    const { clientUserList, dispatch, history, match } = this.props;
    const { params } = match;
    const { id } = params;
    let FleetManager =
      clientUserList && clientUserList.filter((r) => r.userRole === "fleetmanager");
    let TechSuperintendent =
      clientUserList &&
      clientUserList.filter((r) => r.userRole === "superintendent");
    let TechExecutive =
      clientUserList &&
      clientUserList.filter((r) => r.userRole === "technicalexecutive");
    dispatch({ type: "GetFleetManagerlist", data: FleetManager });
    dispatch({ type: "GetTechSuperintendentlist", data: TechSuperintendent });
    dispatch({ type: "GetTechExecutivelist", data: TechExecutive });
    history.push(`/Home/Management/ClientEdit/${id}`);
    dispatch({ type: "ShowSidePan", data: false });
  }
}

function mapDispatchToProps(dispatch) {
  return {
    dispatch,
  };
}
function mapStateToProps(state) {
  return {
    ClientDetails: state.MasterScreenReducer.ClientDetails,
    clientUserList: state.MasterScreenReducer.clientUserList,
  };
}
export default withRouter(
  connect(mapStateToProps, mapDispatchToProps)(ClientManagementDetail)
);
